import defaultState from "./state";

const SolicitudesSELReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_SOLICITUDES_EMPRESA_SEL": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_SOLICITUDES_EMPRESA_SEL": {
      const array = [...action.listaSolicitudes];
      return Object.assign({}, state, {
        listaSolicitudes: array,
        totalSolicitudes: action.total,
        filtrosSolicitudes: action.filtros,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_SEL": {
      const array = [...action.listaSolicitudesFiltrada];
      return Object.assign({}, state, {
        listaSolicitudesFiltrada: array,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_SEL": {
      return Object.assign({}, state, {
        totalSolicitudes: action.total,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_SEL": {
      return Object.assign({}, state, {
        filtrosSolicitudes: action.filtros,
      });
    }

    case "OPEN_CLOSE_MODAL_BORRADOR_SEL": {
      return Object.assign({}, state, {
        isOpenModalBorrador: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_CONTINUE_SEL": {
      return Object.assign({}, state, {
        isOpenModalContinue: action.isOpen,
        idSelected: action.id
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE_SEL": {
      return Object.assign({}, state, {
        isOpenModalDelete: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_EXAMEN": {
      return Object.assign({}, state, {
        isOpenModalEliminarExamenes: action.isOpen,
        examen: action.examen,
        dataSolicitudAgendaSel: action.data,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_SOLICITUD": {
      return Object.assign({}, state, {
        isOpenModalEliminarSolicitud: action.isOpen,
        request: action.request,
      });
    }
    case "SET_SHOWHIDE_FORM_SEL": {
      const actualState = { ...state };
      if (!action.showHideForm) actualState.activeStep = 1;
      return Object.assign({}, state, {
        showHideForm: action.showHideForm,
        activeStep: actualState.activeStep,
        isRequestHeaderUpdate: true,
      });
    }
    case "SET_STEP_SEL": {
      let maxStep = state.lastCompletedStep;
      if (action.step > state.lastCompletedStep) maxStep = action.step;
      return Object.assign({}, state, {
        activeStep: action.step,
        lastCompletedStep: maxStep,
      });
    }
    case "NEXT_STEP_SEL": {
      const nextStep = state.activeStep + 1;
      return Object.assign({}, state, {
        activeStep: nextStep,
        lastCompletedStep: nextStep > state.lastCompletedStep ? nextStep : state.lastCompletedStep,
      });
    }
    case "LAST_STEP_SEL": {
      return Object.assign({}, state, {
        activeStep: state.activeStep - 1,
      });
    }
    case "SET_DATA_NEW_COMPLAIN_SEL": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        isModified: true,
      });
    }
    case "SET_DRAFT_SEL": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        lastCompletedStep: action.jsonData.lastCompletedStep,
      });
    }
    case "EDITING_DRAFT_SEL": {
      return Object.assign({}, state, {
        editingDraft: action.editing,
      });
    }
    case "SET_TIPO_SOLICITUD_SEL": {
      return Object.assign({}, state, {
        selectedTipoSolicitud: action.tipo,
      });
    }
    case "SET_DATA_TRABAJADOR_SEL": {
      return Object.assign({}, state, {
        dataTrabajador: action.data,
      });
    }
    case "UPDATE_DATA_GRID_SOLICITUDES_SEL": {
      return Object.assign({}, state, {
        shouldUpdateDataGrid: action.update,
      });
    }
    case "SET_PENDING_COMPLAINTS_SEL": {
      return Object.assign({}, state, {
        pendingComplaints: action.complaints,
      });
    }
    case "DISABLE_NEW_COMPLAINT_BUTTON_SEL": {
      return Object.assign({}, state, {
        disableContinueNewComplaint: action.disable,
      });
    }
    case "SET_LISTA_EMPLEADOS_SEL": {
      return Object.assign({}, state, {
        listaEmpleados: action.data,
      });
    }
    case "SET_LISTA_EMPLEADOS_TABLA_SEL": {
      return Object.assign({}, state, {
        formatoListaEmpleados: action.formatoListaEmpleados,
      });
    }
    case "SET_SELECTED_CENTER_SEL": {
      return Object.assign({}, state, {
        centroSeleccionado: action.data
      })
    }
    case "SET_DATA_AGENDA_FORM_SEL": {
      return Object.assign({}, state, {
        listaSolicitantes: action.data.solicitantes,
        listaCargos: action.data.cargos,
        listaBaterias: action.data.baterias,
        listaExamenes: action.data.examenes,
        listaExamenesPsicologicos: action.data.psicologicos,
        listaTipoExamenes: action.data.tipoExamenes,
        listaCentros: action.data.centros,
        tiempoSinNombre: action.data.tiempoSinNombre ? action.data.tiempoSinNombre : "48",
      });
    }

    case "SET_DATA_SOLICITUD_AGENDA_SEL": {
      return Object.assign({}, state, {
        dataSolicitudAgendaSel: action.data,
        isLoadFromInput: !!action.isLoadFromInput,
        isModified: true
        // isPoolsUpdate: false,
        // isExamsUpdate: false,
      });
    }

    case "SET_EDIT_WORKERS_SN_SEL": {
      return Object.assign({}, state, {
        isEditTrabajadores: action.open,
      });
    }
    case "CHANGE_STATUS_EXAMENES_ADICIONALES_SEL": {
      return Object.assign({}, state, {
        examenesAdicionales: action.status,
      });
    }
    case "CHANGE_STATUS_EXAMENES_PSICOLOGICOS_SEL": {
      return Object.assign({}, state, {
        examenesPsicologicos: action.status,
      });
    }

    case "SET_DEFAULT_CITY_ID_SEL": {
      return Object.assign({}, state, {
        defaultCityId: action.idCity,
      });
    }

    case "SET_DATA_BORRADOR_SEL": {
      return Object.assign({}, state, {
        defaultCityId: action.data.defaultCityId,
        examenesAdicionales: action.data.examenesAdicionales,
        examenesPsicologicos: action.data.examenesPsicologicos,
        dataSolicitudAgendaSel: action.data.dataSolicitudAgendaSel,
      });
    }

    case "SET_DATA_SOLICITUD_SHOW_SEL": {
      return Object.assign({}, state, {
        selectedSolicitudShow: action.data
      })
    }

    case "SET_WORKERS_UDATED_SEL": {
      return Object.assign({}, state, {
        isWorkersUpdate: action.status,
        isRequestHeaderUpdate: action.status,
      });
    }

    case "SET_POOLS_UPDATED_SEL": {
      return Object.assign({}, state, {
        isPoolsUpdate: action.status,
      });
    }

    case "SET_EXAMS_UDATED_SEL": {
      return Object.assign({}, state, {
        isExamsUpdate: action.status,
      });
    }

    case "SET_HEADERS_UDATED_SEL": {
      return Object.assign({}, state, {
        isRequestHeaderUpdate: action.status,
      });
    }

    case "ABRIR_CERRAR_MODAL_NUEVA_SOLICITUD_SEL": {
      return Object.assign({}, state, {
        openModalButtonNuevaSolicitud: action.status,        
      });
    }

    case "SET_ID_BORRADOR_SEL": {
      const _arr = state.dataSolicitudAgendaSel;
      _arr.idSolicitud = action.Id;
      return Object.assign({}, state, {
        dataSolicitudAgendaSel: _arr,
      });
    }

    case "SET_STATE_EDIT_BORRADOR_SEL": {
      return Object.assign({}, state, {
        editarBorrador: action.status,
      });
    }

    case "SET_CLEAN_SOLICITUD_AGENDA_SEL": {
      return Object.assign({}, state, {
        isOpenModalContinue: false,
        idSelected: null,
        isWorkersUpdate: false,
        isPoolsUpdate: false,
        isExamsUpdate: false,
        isRequestHeaderUpdate: false,
        examenesPsicologicos: false,
        examenesAdicionales: false,
        defaultCityId: null,
        editarBorrador: false,
        isLoadFromInput: false,
        centroSeleccionado: null,
        dataSolicitudAgendaSel: {
          idSolicitud: null,
          solicitante: null,
          centroCostos: null,
          cargo: null,
          tipoEvaluacion: null,
          baterias: [],
          fechaReferencia: null,
          fechaReferenciaEnd: null,
          examenesAdicionales: [],
          examenesPsicologicos: [],
          observaciones: null,
          listaEmpleados: [],
        },
        isModified: false,
        selectedSolicitudShow: null,
        selectedTipoSolicitud: {
          Icon: "2", name: "Borrador de solicitud", column: "EstadoDenuncia", value: { text: "borrador", value: 6 } 
        },
      });
    }
    case "SET_CLEAN_DATA_COMPLAIN_SEL": {
      return Object.assign({}, state, {
        isOpenModalContinue: false,
        idSelected: null,
        isModified: false,
        isOpenModalBorrador: false,
        lastCompletedStep: 1,
        activeStep: 0,
        editingDraft: false,
        dataTrabajador: {},
        pendingComplaints: [],
        centroSeleccionado: null,
        jsonData: {
          formInfoSolicitud: {},
          formInfoTrabajador: {},
          formDatoSiniestro: {},
          formDatosEmpresa: {},
          formSolicitante: {},
          formDatosEnfermedad: {},
        },        
      });
    }

    default:
      return state;
  }
};

export default SolicitudesSELReducer;
